import store from "../../utilities/store";
import React, { Component } from "react";
import { Provider } from 'react-redux';
import BarContainer from './BarContainer'

export default class EngagementRingProgressBar extends Component {

  render() {
    return <Provider store={store} >
      <BarContainer {...this.props}></BarContainer>
    </Provider>
  }
}